import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "../../i18n";
import { Reveal, SectionHead } from "./Section";

const Faq = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="px-6 lg:px-12 py-20 lg:py-32 scroll-mt-16" data-testid="faq-section">
      <div className="grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-20">
        <div>
          <SectionHead index="08" overline={t.faq.overline} title={t.faq.title} desc={t.faq.desc} />
        </div>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="border-t border-[#232733]">
            {t.faq.items.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-[#232733]">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-display text-lg lg:text-2xl font-medium tracking-tight text-white hover:text-[#4D8BFF] hover:no-underline py-7 text-left transition-colors"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm lg:text-base text-[#A0AABF] leading-relaxed pb-7 max-w-2xl" data-testid={`faq-content-${i}`}>
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
